<template>
	<div>
		<a-modal :title="types==1?audit ? '流动资产盘盈入库' : '流动资产盘盈入库详情':audit ? '流动资产盘亏出库' : '流动资产盘亏出库详情'" :visible="is_show" width="60%" @cancel="is_show = false" :maskClosable="false" class="gufiiguy">
			<template slot="footer">
				<a-button key="back" @click="is_show = false"> 取消 </a-button>
				<a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
				<a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
				<a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
			</template>
			<div ref="sadsada">
			<a-form-model :model="info" :label-col="labelCol3" :wrapper-col="wrapperCol3">
				<div class="title">
                    <span>基本信息</span>
                </div>
				<div class="content">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="审批标题" class="model_span_form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<span>{{ info.title }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="申领单号" class="model_span_form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<span>{{ info.applyCode }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="抄送人" class="model_span_form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<span>{{ info.ccName }}</span>
						</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="标题" class="model_span_form" :label-col="labelCol3" :wrapper-col="wrapperCol3">
							<span>{{ info.title }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请人" class="model_span_form" :label-col="labelCol3" :wrapper-col="wrapperCol3">
							<span>{{ info.createByName }}</span>
						</a-form-model-item>
					</a-col>
						<a-col :span="8">
						<a-form-model-item label="申请时间" class="model_span_form" :label-col="labelCol3" :wrapper-col="wrapperCol3">
							<span>{{ info.createTime }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="盘点原因" class="model_span_form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<span>{{ info.reason }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				</div>
				<div class="title">
                    <span>物品信息</span>
                </div>
                <div class="content">
				<a-row>
					<a-table :data-source="info.details" bordered :pagination="false" style="margin-top: 15px">
						<a-table-column key="name" title="物品名称" data-index="name" />
						<a-table-column key="model" title="规格型号" data-index="model" />
						<a-table-column key="isInspected" title="是否检定" data-index="isInspected">
							<template scope="text">
								{{ instrumentMap[text] }}
							</template>
						</a-table-column>
						<a-table-column key="storageNum" title="库存数量" ellipsis="true" data-index="storageNum" />
						<a-table-column key="inventoryNum" :title="types==1?'盘点后增加数量':'盘点后减少数量'" data-index="inventoryNum" width="200px" />
						<a-table-column key="unit" title="单位" data-index="unit" />
					</a-table>
				</a-row>
				</div>
				<div class="title" v-if="!audit && recordNumber==1">
                   <span>审批记录</span>
                </div>
                <div class="content" v-if="!audit  && recordNumber==1">
                   <auditModel ref="auditModel"></auditModel>
                </div>
			</a-form-model>
			</div>
		</a-modal>
		<!-- 撤销提示 -->
		<preview ref="preview" />
		<a-modal v-model="is_revocation" :title="result==3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'" on-ok="handleOkReason">
			<template slot="footer">
				<a-button key="back" @click="is_revocation = false"> 取消 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result==3"> 驳回 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result==2"> 通过 </a-button>
			</template>
			<a-textarea placeholder="请输入原因" v-model="comment" />
		</a-modal>
		<transferModal ref="transferModal" @sure="handleSure" />
	</div>
</template>
<script>
import auditModel from './audit.vue'
import { download_file_java } from '@/utils/request'
	import {
		getClaimByBusiness,
		act_task_audit,
	} from '@/api/activiti'
	import debounce from 'lodash/debounce'
	import {
		act_sku_num,
		consumables_get,
	} from '@/api/assetmenag'
	import {
		checkPermission
	} from '@/utils/permissions'
	import preview from '@/components/module/prview'
	import transferModal from '@/views/activiti/modules/TransferModal.vue'
	import Watermark from '../../../utils/watermark'
	export default {
		props: {
			audit: {
				type: Boolean,
				default: true,
			},
		},
		components:{
			preview,
			transferModal,
			auditModel
		},
		data() {
			return {
				recordNumber: 0,
				is_revocation: false,
				result: '',
				comment: '', //驳回原因
				is_show: false,
				info: {},
				labelCol: {
					span: 6
				},
				wrapperCol: {
					span: 18
				},
				labelCol2: {
					span: 3
				},
				wrapperCol2: {
					span: 21
				},
				labelCol3: {
					span: 9
				},
				wrapperCol3: {
					span: 15
				},
				record: null,
				assetsExportConsumables: checkPermission('asset:claim:checkSku'),
				types:'',
			}
		},
		activated() {},
		watch: {},
		created() {},
		mounted() {
			console.log(this.assetsExportConsumables)
		},
		methods: {
			handleSure() {
				this.is_show = false
				this.$emit('ok')
			},
			//预览文件
			previewFile(file) {
				console.log(file)
				window.open(file.preUrl)
			},
			show_img(idx, imgs) {
				var row = {
					index: idx,
					imgs: imgs,
				}
				this.$refs.preview.show(row)
			},
			show(record) {
				 this.recordNumber =  record.recordNumber
				this.record = record
				console.log(record.businessKey)
				consumables_get(record.businessKey).then((res) => {
					console.log(res)
					if (res.code != 200) {
						this.$message.error(res.msg)
						return
					}
					this.info = res.data
					this.types=res.data.types
					this.is_show = true
					this.$nextTick(()=>{
						  if(!this.audit && this.recordNumber==1) {
                             this.$refs.auditModel.show(record)
                            }
                         Watermark.set('安联云管家' , this.$refs.sadsada)
                    })
				})
			},
			//驳回
			reject(result_) {
				if (result_ == 1) {
					this.$refs.transferModal.show({
						record: this.record,
					})
				} else {
					this.is_revocation = true
					this.comment = ''
					this.result = result_
				}
			},
			handleOkReason: debounce(function(){
				if(this.result==3){
					if (this.comment == '') {
						this.$message.error('请输入驳回意见！')
					} else {
						this.succeed(this.result)
					}
				}else if(this.result==2){
					this.succeed(this.result)
				}
			}, 1000, {
				'leading': true,
				'trailing': false
			}),
			//审批
			succeed(result_) {
				act_task_audit({
					taskId: this.record.id,
					procDefKey: this.record.processDefKey,
					procInstId: this.record.procInstId,
					procName: this.record.processName,
					applyer: this.record.applyer,
					result: result_,
					businessKey: this.record.businessKey,
					comment: this.comment,
				}).then((res) => {
					if (res.code != 200) {
						this.$message.error(res.msg)
						return
					}
					this.$message.success('审批成功')
					this.$emit('ok')
					this.is_show = false
					this.is_revocation = false
				})
			},
		},
	}
</script>
<style>
</style>
